export const supervisionSessionItems = [
	{
		type: "SET",
		stimulus: {
			id: 1,
			content: {
				instruction:
					"Watch the video and select the correct answer from the options provided.",
				passage: {
					title: "Leave No One Behind",
					paragraphs: [
						{
							text: "Brian, MSW invites the whole supervision group on a quick 10-mile trail warm-up.",
							number: 1,
						},
					],
				},
				media: [
					{
						id: "vibkZrqobSCFvWzH1P5UZJT",
						url: "vibkZrqobSCFvWzH1P5UZJT",
						type: "video",
						transcript:
							"Okay team, before we get started how about a 10-mile trail warmup to get the blood pumping!",
					},
				],
			},
			metadata: {
				type: "READING",
				skill: "VIDEO",
				title: "Reading Stimulus",
			},
		},
		items: [
			{
				id: 10,
				type: "MCSS",
				content: {
					parentId: 1,
					parentType: "SET",
					stem: "Which ethical principle is breached first and foremost in Brian's supervision plan?",
					choices: [
						{
							id: "100f17b1-2f1e-4d07-af6b-f17de7857933",
							stem: "Respect for dignity & worth of persons",
							text: "Respect for dignity & worth of persons",
							isCorrect: true,
							explanation: `**Respect for dignity & worth of persons** is the ethical principle most clearly breached in Brian's supervision plan. By proposing a physically demanding group activity without considering the needs of a supervisee who uses a wheelchair, Brian fails to recognize and accommodate individual differences and abilities. This oversight can lead to exclusion, discomfort, and a sense of marginalization for the supervisee, undermining their inherent dignity and right to equitable participation.

Other principles, such as competence, integrity, and self-care, are important but are not the primary concern in this scenario. The core issue is the lack of respect for diversity and the failure to create an inclusive environment that honors each person's value.

**Key takeaways:**
- **Respect for dignity & worth of persons** requires supervisors to recognize, respect, and accommodate individual differences, including ability status.
- Inclusive supervision practices foster a sense of belonging and support for all group members.
- Failing to consider accessibility needs can result in ethical breaches and harm to supervisees.

**References:**
- National Association of Social Workers. (n.d.). *Code of ethics: Dignity and worth of the person*. University at Buffalo School of Social Work. https://socialwork.buffalo.edu/admissions/is-social-work-right-career-for-me/values-ethics.html`,
							numFirstSelections: 146,
						},
						{
							id: "ea2fb96d-a000-435d-b5e1-5617853f0c54",
							stem: "Competence",
							text: "Competence",
							isCorrect: false,
							numFirstSelections: 42,
						},
						{
							id: "ea2fb96d-a000-435d-b5e1-5617853f0c54-ged",
							stem: "Integrity",
							text: "Integrity",
							isCorrect: false,
							numFirstSelections: 42,
						},
						{
							id: "9bd9f1ff-0001-4704-8fab-b98742b29e05",
							stem: "Self-care",
							text: "Self-care",
							isCorrect: false,
							numFirstSelections: 34,
						},
					],
					instruction: "Choose the best answer",
					highlights: null,
					media: null,
				},
				tags: [
					{
						id: 6479,
						type: "Skill",
						label: "Reading",
						breadcrumb: "Reading",
					},
				],
				metadata: {
					type: "MCSS",
					skill: "READING",
					title: "Multiple Choice Single Selection",
					topics: ["Supervision Certification"],
				},
				response: {
					maximumScore: 1,
					correctResponse: [
						{
							id: "100f17b1-2f1e-4d07-af6b-f17de7857933",
						},
					],
					numChoicesRequired: {
						max: 1,
						min: 1,
					},
				},
			},
		],
	},
	{
		type: "SET",
		stimulus: {
			id: 2,
			content: {
				instruction:
					"Watch the video and write your answer in the text box provided.",
				passage: {
					title: "Leave No One Behind",
					paragraphs: [
						{
							text: "Brian, MSW invites the whole supervision group on a quick 10-mile trail warm-up.",
							number: 1,
						},
					],
				},
				media: [
					{
						id: "vibkZrqobSCFvWzH1P5UZJT",
						url: "vibkZrqobSCFvWzH1P5UZJT",
						type: "video",
						transcript:
							"Okay team, before we get started how about a 10-mile trail warmup to get the blood pumping!",
					},
				],
			},
			metadata: {
				type: "INTEGRATED_WRITING_STIMULUS",
				skill: "VIDEO",
				title: "Integrated Writing Stimulus",
				topics: ["Supervision Certification"],
			},
		},
		items: [
			{
				id: 20,
				versionId: 1,
				content: {
					parentId: 2,
					parentType: "SET",
					stem: "Draft two policy lines you would add to the supervision handbook to prevent this lapse.",
					choices: [],
					instruction:
						"Watch the video and write your answer in the text box provided.",
					media: null,
				},
				tags: [
					{
						id: 6480,
						type: "Skill",
						label: "Writing",
						breadcrumb: "Writing",
					},
				],
				response: {
					maximumScore: 25,
					subskillsSchema: [
						{
							name: "Policy Relevance",
							icon: "file-document-outline",
							description:
								"Policy lines directly address the specific lapse or problem identified in the scenario.",
							maxScore: 5,
						},
						{
							name: "Clarity & Specificity",
							icon: "format-list-bulleted",
							description:
								"Policies are clear, concrete, and actionable, avoiding vague or general statements.",
							maxScore: 5,
						},
						{
							name: "Professional Language",
							icon: "account-tie-outline",
							description:
								"Uses appropriate policy and organizational language suitable for a handbook audience.",
							maxScore: 5,
						},
						{
							name: "Feasibility",
							icon: "check-circle-outline",
							description:
								"Policies could realistically be implemented in a real-world supervision setting.",
							maxScore: 5,
						},
						{
							name: "Promotes Best Practice",
							icon: "star-outline",
							description:
								"Policies align with ethical, inclusive, and effective supervision standards.",
							maxScore: 5,
						},
					],
				},
				metadata: {
					type: "INTEGRATED_WRITING_RESPONSE",
					skill: "WRITING",
					title: "Integrated Writing Response",
					topics: ["Supervision Certification"],
				},
				score: null,
			},
		],
	},
	{
		type: "SET",
		stimulus: {
			id: 3,
			content: {
				instruction: "Watch the video and mark the required items.",
				passage: {
					title: "Leave No One Behind",
					paragraphs: [
						{
							text: "Brian, MSW invites the whole supervision group on a quick 10-mile trail warm-up.",
							number: 1,
						},
					],
				},
				media: [
					{
						id: "vibkZrqobSCFvWzH1P5UZJT",
						url: "vibkZrqobSCFvWzH1P5UZJT",
						type: "video",
						transcript:
							"Okay team, before we get started how about a 10-mile trail warmup to get the blood pumping!",
					},
				],
			},
			metadata: {
				type: "INTEGRATED_MARKING_ANSWER_STIMULUS",
				skill: "VIDEO",
				title: "Integrated Marking Answer Stimulus",
				topics: ["Supervision Certification"],
			},
		},
		items: [
			{
				id: 30,
				versionId: 1,
				content: {
					parentId: 3,
					parentType: "SET",
					stem: "What aspect of this scene violates the reasonable accommodation clause of the Americans with Disabilities Act or Canadian Human Rights Act?",
					choices: [],
					instruction:
						"Watch the video and mark the required aspect of the scene.",
					media: [
						{
							id: "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/demo/acme/LNOB.png",
							url: "https://ajxjsnuynuxigljdrsyk.supabase.co/storage/v1/object/public/memorang-assets/demo/acme/LNOB.png",
							type: "image",
						},
					],
				},
				tags: [
					{
						id: 6480,
						type: "Skill",
						label: "Marking",
						breadcrumb: "Marking",
					},
				],
				response: {
					maximumScore: 10,
					subskillsSchema: [
						{
							name: "Accuracy",
							icon: "crosshairs-gps",
							maxScore: 5,
							description:
								"Correctly identifies the specific feature (wheelchair blockage) that violates accessibility requirements",
						},
						{
							name: "Speed",
							icon: "timer-outline",
							maxScore: 5,
							description:
								"Meets the time requirement for marking the required aspect.",
						},
					],
				},
				metadata: {
					type: "MARKING_ANSWER",
					skill: "MARKING",
					title: "Marking Answer",
					topics: ["Supervision Certification"],
				},
				score: null,
			},
		],
	},
	{
		type: "SET",
		stimulus: {
			id: 4,
			content: {
				instruction: "Watch the video and record your answer.",
				passage: {
					title: "Leave No One Behind",
					paragraphs: [
						{
							text: "Brian, MSW invites the whole supervision group on a quick 10-mile trail warm-up.",
							number: 1,
						},
					],
				},
				media: [
					{
						id: "vibkZrqobSCFvWzH1P5UZJT",
						url: "vibkZrqobSCFvWzH1P5UZJT",
						type: "video",
						transcript:
							"Okay team, before we get started how about a 10-mile trail warmup to get the blood pumping!",
					},
				],
			},
			metadata: {
				type: "LS_STIMULUS",
				skill: "VIDEO",
				title: "Listen Speak Stimulus",
				topics: ["Supervision Certification"],
			},
		},
		items: [
			{
				id: 40,
				type: "AUDIO_INPUT_EMOTION",
				content: {
					parentId: 4,
					parentType: "SET",
					stem: "Record a 60-second supportive conversation with Brian explaining inclusive practice principles.",
					choices: [],
					instruction: "Watch the video and record your answer.",
					media: null,
				},
				tags: [
					{
						id: 6481,
						type: "Skill",
						label: "Speaking",
						breadcrumb: "Speaking",
					},
				],
				response: {
					maximumScore: 25,
					maximumDuration: 60,
					subskillsSchema: [
						{
							maxScore: 5,
							name: "Supportive Tone",
							icon: "hand-heart-outline",
							description:
								"Voice, phrasing, and affect convey warmth, respect, and a nonjudgmental attitude throughout the conversation.",
						},
						{
							maxScore: 5,
							name: "Clarity of Explanation",
							icon: "message-outline",
							description:
								"Explains inclusive practice principles in a way that is easy for Brian to understand, using clear and accessible language.",
						},
						{
							maxScore: 5,
							name: "Content Accuracy",
							icon: "check-decagram-outline",
							description:
								"Provides accurate information about inclusive practice, consistent with current standards or the ASWB blueprint.",
						},
						{
							maxScore: 5,
							name: "Cultural Humility & Inclusivity",
							icon: "earth",
							description:
								"Recognizes differences, avoids assumptions, uses affirming language, and demonstrates cultural humility.",
						},
						{
							maxScore: 5,
							name: "Communication Skills",
							icon: "account-tie-outline",
							description:
								"Pace, articulation, and organization are appropriate for a supportive professional setting.",
						},
					],
				},
				metadata: {
					type: "AUDIO_INPUT_EMOTION",
					skill: "SPEAKING",
					title: "Audio Input Item",
					topics: ["Supervision Certification"],
				},
				score: 0,
			},
		],
	},
	{
		type: "SET",
		stimulus: {
			id: 5,
			content: {
				instruction:
					"Watch the video and write your answer in the text box provided.",
				passage: {
					title: "Leave No One Behind",
					paragraphs: [
						{
							text: "Brian, MSW invites the whole supervision group on a quick 10-mile trail warm-up.",
							number: 1,
						},
					],
				},
				media: [
					{
						id: "vibkZrqobSCFvWzH1P5UZJT",
						url: "vibkZrqobSCFvWzH1P5UZJT",
						type: "video",
						transcript:
							"Okay team, before we get started how about a 10-mile trail warmup to get the blood pumping!",
					},
				],
			},
			metadata: {
				type: "INTEGRATED_WRITING_STIMULUS",
				skill: "VIDEO",
				title: "Integrated Writing Stimulus",
				topics: ["Supervision Certification"],
			},
		},
		items: [
			{
				id: 50,
				versionId: 1,
				content: {
					parentId: 5,
					parentType: "SET",
					stem: "Write a 200-word reflective memo linking this situation to Reamer's Step-7 'monitor outcomes' and explaining how you would ensure future supervision activities are inclusive.",
					choices: [],
					instruction:
						"Watch the video and write your answer in the text box provided.",
					media: null,
				},
				tags: [
					{
						id: 6480,
						type: "Skill",
						label: "Writing",
						breadcrumb: "Writing",
					},
				],
				response: {
					maximumScore: 25,
					subskillsSchema: [
						{
							maxScore: 5,
							name: "Reflective Practice & Self-Assessment",
							icon: "account-question-outline",
							description:
								"Thoughtfully examines own actions and reasoning, connects experience to Reamer's Step-7 ('monitor outcomes').",
						},
						{
							maxScore: 5,
							name: "Outcome Monitoring & Evaluation",
							icon: "chart-bar",
							description:
								"Clearly explains how monitoring outcomes applies, identifies metrics or methods to track progress.",
						},
						{
							maxScore: 5,
							name: "Inclusivity & Cultural Humility",
							icon: "earth",
							description:
								"Addresses how to make supervision more inclusive (cultural, linguistic, ability), and reflects anti-oppressive lens.",
						},
						{
							maxScore: 5,
							name: "Critical Thinking & Synthesis",
							icon: "lightbulb-on-outline",
							description:
								"Integrates situation, framework, and future actions logically and insightfully.",
						},
						{
							maxScore: 5,
							name: "Written Communication",
							icon: "file-document-outline",
							description:
								"Memo is clear, well-organized, professional, and within word limit.",
						},
					],
				},
				metadata: {
					type: "INTEGRATED_WRITING_RESPONSE",
					skill: "WRITING",
					title: "Integrated Writing Response",
					topics: ["Supervision Certification"],
					taskType: "default",
				},
				score: null,
			},
		],
	},
];
